import cuid from 'cuid';

export default function guidGenerator() {
    return cuid();
}
